import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // Pour les titres dynamiques par page
import styled, { createGlobalStyle } from "styled-components";
import Navbar from "./components/Navbar";
import Accueil from "./pages/Accueil";
import Societe from "./pages/Societe";
import Realisations from "./pages/Realisations";
import Contact from "./pages/Contact";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import MentionsLegales from "./pages/MentionsLegales";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import NotFound from "./pages/NotFound";
import Analytics from "./components/Analytics";

// Initialisation déplacée dans CookieBanner pour respect RGPD
// ReactGA.initialize("G-DJE0RJ2XHC");

// Global styles
const GlobalStyle = createGlobalStyle`
  :root {
    --color-background: #1a1a1a;
    --color-text: #13519a;
    --color-accent: #ef6500;
    --color-surface: #2c2c2c;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: 'Poppins', sans-serif; 
    background-color: var(--color-background);
    color: var(--color-text);
  }

  #root {
    min-height: 100vh; /* Use min-height to ensure it fills the screen */
    display: flex;
    flex-direction: column;
  }

  a {
    color: var(--color-accent);
    text-decoration: none;
    transition: opacity 0.2s ease-in-out;
  }

  a:hover {
    opacity: 0.8;
  }
`;

const ContentContainer = styled.main`
  flex: 1; /* Allow content to grow and push footer down */
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  box-sizing: border-box;
  /* Important : pour que le contenu passe au-dessus des particules */
  position: relative;
  z-index: 1;
`;

function App() {

  return (
    // HelmetProvider permet aux pages enfants de modifier le <title> et les meta tags
    <HelmetProvider>
      <Router>
        <Analytics />
        <GlobalStyle />
        <AnimatedBackground />
        <Navbar />
        <ContentContainer>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/societe" element={<Societe />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/politique-confidentialite"
              element={<PolitiqueConfidentialite />}
            />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ContentContainer>
        <CookieBanner />
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
